export default __webpack_public_path__ + "static/media/78t.68c9ea5d.jpg";